module.exports = __webpack_public_path__ + "media/images/emblems/Starrkirch-Wil-blason-f4fd825cbc70290c783f6f5901da69d5.png";